import React, { useState, useEffect, useContext, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PageContext } from "./PageProvider";
import { v4 as uuidv4 } from "uuid";
import "css/componentCss/PersonnelPopup.css";
import "css/componentCss/Code.css";
import {getUserInfo} from "api/commonUtil"
import { getMenuList, getParentMenuIdByUri, URL } from "pages/menu";
import ChangePwModal from "./modal/ChangePwModal";
import BasicButton from "./button/BasicButton";
import NewOrderNotification from "./NewOrderNotification";

/** 대,중,소 카데고리 Link가 걸려 있는 헤더 */
function Header() {
	let userInfo = getUserInfo();
	
	const {gnbId, setGnbId, setLnbId, setSnbId} = useContext(PageContext);
	const gMenuItems = useMemo(() => [...getMenuList()], [userInfo?.userSeq]);
    // const [signNumber, setSignNumber] = useState("0");
    const [changePwModalOpen, setChangePwModalOpen] = useState(false);

	// uri 기준으로 top~현재 menuId목록 조회
	const parentMenuIds = getParentMenuIdByUri(useLocation().pathname);
	useEffect(() => {
		if(parentMenuIds.length === 0) {
			setGnbId("");
			setLnbId("");
			setSnbId("");
		} else {
			setGnbId(parentMenuIds[0]);
			if(parentMenuIds.length > 1) {
				setLnbId(parentMenuIds[1])
			} else {
				setLnbId("");
			}
			if(parentMenuIds.length > 2) {
				setSnbId(parentMenuIds[2])
			} else {
				setSnbId("");
			}
		}
	}, [parentMenuIds]);

    const navigate = useNavigate();

    const logInHandler = () => {
        navigate(URL.LOGIN);
    };
    const logOutHandler = async () => {
		localStorage.removeItem("accessToken");
		localStorage.removeItem("refreshToken");
		navigate(URL.LOGIN);
    };


    return (
        // <!-- header -->
        <div className="header">
            <div className="inner">
                <h1 className="logo">
                    <Link to={URL.MAIN} className="w" >
                        <img src="/assets/images/vertical_logo.png" alt="스노우폭스플라워" />
                    </Link>
                </h1>

                <div className="gnb">
                    <h2 className="blind">주메뉴</h2>
                    <ul>
					{userInfo && gMenuItems.map((menuItem) => (
						// <li key={menuItem.id}>
						<li key={uuidv4()}>
							{/* <span onClick={gnbClick} data-gnb-id={menuItem.menuId} className={gnbId === menuItem.menuId ? "active" : ""}>
								{menuItem.label}
							</span> */}
							<Link to={menuItem.menuUrl} className={gnbId === menuItem.menuId ? "active" : ""}>
								{menuItem.label}
							</Link>
						</li>
					))}
                    </ul>
                </div>

                {/* <!-- PC web에서 보여지는 영역 --> */}
                <div className="user_info">
                    {/* 로그아웃 : 로그인 정보 있을때 */}
                    {userInfo && (
                        <div className="table-buttons">
                            <span className="person">
                                {userInfo.userNm}
								{/* ({" " + signNumber + " "}) */}
                            </span>
                            {/* 님이, 로그인하셨습니다. */}
                            <BasicButton className="" label="로그아웃" onClick={logOutHandler} />
                            <BasicButton
								className="btn-mod"
                                label={"비밀번호 변경"}
                                onClick={()=>setChangePwModalOpen(true)}
                            />
                        </div>
                    )}
                </div>
            </div>

            <ChangePwModal
                width={500}
                height={300}
                title="비밀번호 변경"
                isOpen={changePwModalOpen}
                onClose={()=> setChangePwModalOpen(false)}
            />

			{/* 신규 주문 확인 */}
			<NewOrderNotification />
        </div>
    );
}

// const mapStateToProps = (data) => data.tabs;
// export default connect(mapStateToProps)(Header);
export default Header;
